import React from "react";
import PropTypes from "prop-types";
import calenderIcon from "../../../assets/images/opp.svg";
import profileIcon from "../../../assets/images/profile.svg";
import flagIcon from "../../../assets/images/flagIcon.svg";
import AdvertisementImage from "../../../assets/images/Advertisement.svg";
// import router link
import { Link } from "react-router-dom";

// import moment
import moment from "moment";
import "moment/locale/fr";

// import common components
import Lister from "../../common/Lister";

// import utilities
import {
  calculateCol,
  getObjectByKey,
  slugify,
} from "../../../helpers/utilities";

// import dummies
import { COUNTRY, OPPORTUNITY } from "../../../helpers/dummies";

// import constants
import {
  ITEMS_TO_DISPLAY_SM,
  ITEMS_TO_DISPLAY_XS,
} from "../../../helpers/constants";

const ListOpportunity = ({
  items,
  itemsPerRow,
  listerClasses,
  withDiscover,
  withPagination,
  loading
}) => {

  return (
    <React.Fragment>
      <Lister
        listerClasses={`${listerClasses} opportunities`}
        withPagination={withPagination}
        withDiscover={withDiscover}
        discoverOptions={{ discoverLink: "#" }}
      >
     {/* {loading && <h1>Loading....</h1>} */}
        {items &&
            items.map((item, index) => {
            let itemOpportunity = {
              ...item,
              // image: item.image ? item.image : OPPORTUNITY.image,
              image: OPPORTUNITY.image,
              officialLink: item.officialLink
                ? item.officialLink
                : OPPORTUNITY.officialLink,
              coordinates: item.coordinates
                ? item.coordinates
                : OPPORTUNITY.coordinates,
              country: item.country ? item.country : COUNTRY,
              eligible:item.eligibility_questions ? item.eligibility_questions : false
            };
                        
            return (
              <>
                <OpportunityItem
                  key={`bourse_item_${index}`}
                  col={calculateCol(itemsPerRow)}
                  {...itemOpportunity}
                />
                {(index + 1) % 10  === 0 &&
                (<div className="col-lg-4 col-md-6 col-sm-12  advertisement-box">
                  <img className="" src={AdvertisementImage} alt="Image" />
                </div>)}
              </>
            );
          })}
          {loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>}
     
      </Lister>
    </React.Fragment>
  );
};
ListOpportunity.propTypes = {
  items: PropTypes.array,
  itemsPerRow: PropTypes.number,
  listerClasses: PropTypes.string,
  withPagination: PropTypes.bool,
};
ListOpportunity.defaultProps = {
  itemsPerRow: ITEMS_TO_DISPLAY_XS,
  listerClasses: "g-3 mt-5",
  withDiscover: false,
  withPagination: false,
};
export default ListOpportunity;

/**
 * Opportunity item.
 */
const OpportunityItem = ({
  col,
  image,
  publicId,
  officialLink,
  name,
  description,
  mention,
  bourseDuree,
  priseCharge,
  formationLevel,
  endDate,
  minAge,
  maxAge,
  city,
  type,
  country,
  eligible
}) => (
  <div className={`col-lg-${col} col-md-6 col-sm-12 title-box`}>
    {/* <Link to={`/opportunites/${publicId}`}> */}
    {/* <Link to={{
                pathname: `/opportunites/${publicId}}`,   
                state: {
                     code: publicId,
                     formationName: name,  
                    },
                  }}> */}
{ eligible ? (
       <Link 
       to={{
          pathname: `/opportunites/eligibities/${slugify(name)}`,
          state: {
            code: publicId,
            formationName: name,
          },
        }}
       
       /* this is code before added the opportunity verification*/
        // to={{
        //   pathname: `/opportunites/${slugify(name)}`,
        //   state: {
        //     code: publicId,
        //     formationName: name,
        //   },
        // }}
       >
        <article className="box">
          <div className="box-image">
            <img src={image} alt="" />
          </div>
          <div className="box-container">
            <p className="box-heading">{name}</p>
            <p className="box-para line-clamp-2 min-h-[44px]" dangerouslySetInnerHTML={{__html:description}}/>
       
            {/* <div className="box-badges">
                  <ul>
                      {[formationLevel, mention].map((tag, index) => (
                          <li key={`bourse_tag_item_${index}`} className="badge badge-soft-info box-badge">
                              {tag}
                          </li>
                      ))}
                      {[bourseDuree, getObjectByKey(priseCharge, "name")].map((category, index) => (
                          <li key={`bourse_category_item_${index}`} className="badge badge-soft-warning box-badge">
                              {category}
                          </li>
                      ))}
                  </ul>
              </div> */}
       
            {/* <div className="box-meta">
          <ul>
            <li>
              <a href="#" title="Pays hôte">
                <i className="bx bx-map-pin"></i>
                <span>{`${country.name ? country.name : ""}${
                  country.city ? ` ${country.city}` : ""
                }`}</span>
              </a>
            </li>
            <li>
              <a href="#" title="Tranche d'âge éligible">
                <i className="bx bx-user"></i>
                <span>{`${minAge}-${maxAge}`}</span>
              </a>
            </li>
            <li>
              <a href="#" title="Date limite de candidature">
                <i className="bx bxs-hourglass"></i>
                <span>{moment(new Date(endDate)).format("DD MMM YYYY")}</span>
              </a>
            </li>
          </ul>
        </div> */}
            <div className="box-meta min-h-[27px]">{type}</div>
       
            {/* <div className="flex gap-5 mt-3 ">
            <div>
              <p>
                <img src={oppImage} alt="" />
                <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
              </p>
            </div>
            <div>
              <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
            </div>
            <div>
              <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
            </div>
          </div> */}
       
            <div className="opportuniti-box">
              <div className="opportuniti-box-content">
                <img src={calenderIcon} alt="Opportunity Image" />
                <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
              </div>
              <div className="opportuniti-box-content">
                <img src={profileIcon} alt="Opportunity Image" />
                <p>
                  {/* 18-24 */}
                  {minAge}-{maxAge}
                </p>
              </div>
              <div className="opportuniti-box-content">
                <img src={flagIcon} alt="Opportunity Image" />
                <p>Togo</p>
              </div>
            </div>
          </div>
        </article>
       </Link>
    
    ):(
      <>
      <Link 
      /* this is code before added the opportunity verification*/
         to={{
           pathname: `/opportunites/${slugify(name)}`,
           state: {
             code: publicId,
             formationName: name,
           },
         }}
       >
         <article className="box">
           <div className="box-image">
             <img src={image} alt="" />
           </div>
           <div className="box-container">
             <p className="box-heading">{name}</p>
             <p className="box-para line-clamp-2 min-h-[44px]" dangerouslySetInnerHTML={{__html:description}}/>
   
             {/* <div className="box-badges">
                   <ul>
                       {[formationLevel, mention].map((tag, index) => (
                           <li key={`bourse_tag_item_${index}`} className="badge badge-soft-info box-badge">
                               {tag}
                           </li>
                       ))}
                       {[bourseDuree, getObjectByKey(priseCharge, "name")].map((category, index) => (
                           <li key={`bourse_category_item_${index}`} className="badge badge-soft-warning box-badge">
                               {category}
                           </li>
                       ))}
                   </ul>
               </div> */}
   
             {/* <div className="box-meta">
           <ul>
             <li>
               <a href="#" title="Pays hôte">
                 <i className="bx bx-map-pin"></i>
                 <span>{`${country.name ? country.name : ""}${
                   country.city ? ` ${country.city}` : ""
                 }`}</span>
               </a>
             </li>
             <li>
               <a href="#" title="Tranche d'âge éligible">
                 <i className="bx bx-user"></i>
                 <span>{`${minAge}-${maxAge}`}</span>
               </a>
             </li>
             <li>
               <a href="#" title="Date limite de candidature">
                 <i className="bx bxs-hourglass"></i>
                 <span>{moment(new Date(endDate)).format("DD MMM YYYY")}</span>
               </a>
             </li>
           </ul>
         </div> */}
             <div className="box-meta min-h-[27px]">{type}</div>
   
             {/* <div className="flex gap-5 mt-3 ">
             <div>
               <p>
                 <img src={oppImage} alt="" />
                 <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
               </p>
             </div>
             <div>
               <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
             </div>
             <div>
               <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
             </div>
           </div> */}
    
             <div className="opportuniti-box">
               <div className="opportuniti-box-content">
                 <img src={calenderIcon} alt="Opportunity Image" />
                 <p>{moment(new Date(endDate)).format("DD MMM YYYY")}</p>
               </div>
               <div className="opportuniti-box-content">
                 <img src={profileIcon} alt="Opportunity Image" />
                 <p>
                   {/* 18-24 */}
                   {minAge}-{maxAge}
                 </p>
               </div>
               <div className="opportuniti-box-content">
                 <img src={flagIcon} alt="Opportunity Image" />
                 <p>Togo</p>
               </div>
             </div>
           </div>
         </article>
       </Link>
    </>
    )}
  </div>
);
